/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespInteriorsModule_user = {
    readonly " $fragmentRefs": FragmentRefs<"SbSharedInteriorsPhotoModalRenderer_user" | "SbRespInteriorsPhotoGallery_user" | "SbRespInteriorsPhotoCarousel_user">;
    readonly " $refType": "SbRespInteriorsModule_user";
};
export type SbRespInteriorsModule_user$data = SbRespInteriorsModule_user;
export type SbRespInteriorsModule_user$key = {
    readonly " $data"?: SbRespInteriorsModule_user$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespInteriorsModule_user">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespInteriorsModule_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedInteriorsPhotoModalRenderer_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespInteriorsPhotoGallery_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespInteriorsPhotoCarousel_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};
(node as any).hash = 'a86774c2376405b5f1ee164b90c538f7';
export default node;
